import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { CommonDataService } from '@sb-tools/typescript/services/common-data.service';
import { AuthenticationService } from '@sb-tools/typescript/authentication/authentication.service';
import { UserRole } from '@sb-tools/typescript/enums/user-role.enum';

@Injectable()
export class CanActivateWidgetSettingsGuard implements CanActivate {
    constructor(
        private commonDataService: CommonDataService,
        private router: Router,
        private authenticationService: AuthenticationService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (
            this.commonDataService.user.isAdmin ||
            this.commonDataService.user.isSystemAdmin ||
            (this.commonDataService.user.role === UserRole.manager &&
                ['widget/chat/general-settings', 'widget/chat/schedule-settings'].includes(route.data.path))
        ) {
            return true;
        }

        if (
            this.commonDataService.user.role === UserRole.manager &&
            ['widget/general-settings'].includes(route.data.path)
        ) {
            this.router.navigate([state.url.replace('/general', '/chat/general')]);
            return false;
        }

        const community = this.authenticationService.community;
        this.router.navigate([`/${community}/403`], { skipLocationChange: true });
        return false;
    }
}
